export default "__VITE_ASSET__C$iTLlLe__"